import { AnnouncementDetail } from '~/features/announcements/announcement-detail'

export const SiteAnnouncementDetail = () => (
  <AnnouncementDetail parentPageRoute="/announcements" parentPageTitle="直播公告" pageTitle="公告详情" />
)
